// extracted by mini-css-extract-plugin
export default {"code":"D_cT"};